// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from 'flatbuffers';

import { ActionType } from '../tbs/action-type.js';
import { PatchPlayerData, PatchPlayerDataT } from '../tbs/patch-player-data.js';


export class PatchPlayerSlotAction implements flatbuffers.IUnpackableObject<PatchPlayerSlotActionT> {
  bb: flatbuffers.ByteBuffer|null = null;
  bb_pos = 0;
  __init(i:number, bb:flatbuffers.ByteBuffer):PatchPlayerSlotAction {
  this.bb_pos = i;
  this.bb = bb;
  return this;
}

static getRootAsPatchPlayerSlotAction(bb:flatbuffers.ByteBuffer, obj?:PatchPlayerSlotAction):PatchPlayerSlotAction {
  return (obj || new PatchPlayerSlotAction()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
}

static getSizePrefixedRootAsPatchPlayerSlotAction(bb:flatbuffers.ByteBuffer, obj?:PatchPlayerSlotAction):PatchPlayerSlotAction {
  bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
  return (obj || new PatchPlayerSlotAction()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
}

type():ActionType {
  const offset = this.bb!.__offset(this.bb_pos, 4);
  return offset ? this.bb!.readUint16(this.bb_pos + offset) : ActionType.LobbyPatchPlayerSlot;
}

playerId():number {
  const offset = this.bb!.__offset(this.bb_pos, 6);
  return offset ? this.bb!.readUint16(this.bb_pos + offset) : 0;
}

data(obj?:PatchPlayerData):PatchPlayerData|null {
  const offset = this.bb!.__offset(this.bb_pos, 8);
  return offset ? (obj || new PatchPlayerData()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!) : null;
}

static startPatchPlayerSlotAction(builder:flatbuffers.Builder) {
  builder.startObject(3);
}

static addType(builder:flatbuffers.Builder, type:ActionType) {
  builder.addFieldInt16(0, type, ActionType.LobbyPatchPlayerSlot);
}

static addPlayerId(builder:flatbuffers.Builder, playerId:number) {
  builder.addFieldInt16(1, playerId, 0);
}

static addData(builder:flatbuffers.Builder, dataOffset:flatbuffers.Offset) {
  builder.addFieldOffset(2, dataOffset, 0);
}

static endPatchPlayerSlotAction(builder:flatbuffers.Builder):flatbuffers.Offset {
  const offset = builder.endObject();
  return offset;
}


unpack(): PatchPlayerSlotActionT {
  return new PatchPlayerSlotActionT(
    this.type(),
    this.playerId(),
    (this.data() !== null ? this.data()!.unpack() : null)
  );
}


unpackTo(_o: PatchPlayerSlotActionT): void {
  _o.type = this.type();
  _o.playerId = this.playerId();
  _o.data = (this.data() !== null ? this.data()!.unpack() : null);
}
}

export class PatchPlayerSlotActionT implements flatbuffers.IGeneratedObject {
constructor(
  public type: ActionType = ActionType.LobbyPatchPlayerSlot,
  public playerId: number = 0,
  public data: PatchPlayerDataT|null = null
){}


pack(builder:flatbuffers.Builder): flatbuffers.Offset {
  const data = (this.data !== null ? this.data!.pack(builder) : 0);

  PatchPlayerSlotAction.startPatchPlayerSlotAction(builder);
  PatchPlayerSlotAction.addType(builder, this.type);
  PatchPlayerSlotAction.addPlayerId(builder, this.playerId);
  PatchPlayerSlotAction.addData(builder, data);

  return PatchPlayerSlotAction.endPatchPlayerSlotAction(builder);
}
}
